var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "export-to-layout-modal",
        title: "Export to Layout",
        size: "lg",
        "ok-title": "Export",
        "ok-disabled": !_vm.exportAvailable,
      },
      on: { show: _vm.onModalOpen, ok: _vm.processExport },
    },
    [
      _c("Multiselect", {
        staticClass: "mb-3",
        attrs: {
          options: _vm.layouts,
          loading: _vm.isLoading,
          searchable: "",
          multiple: "",
          "custom-label": _vm.customLabel,
          "track-by": "id",
          placeholder: "Export to layout",
        },
        on: {
          "search-change": _vm.searchCustomerLayouts,
          select: (option) => (_vm.selectedLayout = [option]),
        },
        scopedSlots: _vm._u(
          [
            _vm.layouts.length < _vm.layoutsTotalCount
              ? {
                  key: "afterList",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "load-more-btn" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                disabled: _vm.isLoading,
                                variant: "outline-primary",
                              },
                              on: { click: _vm.getLayouts },
                            },
                            [_vm._v("\n          Load More\n        ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _vm.selectedLayout,
          callback: function ($$v) {
            _vm.selectedLayout = $$v
          },
          expression: "selectedLayout",
        },
      }),
      _vm._v(" "),
      _c("b-form-radio-group", {
        attrs: { name: "select-strategy", options: _vm.options },
        model: {
          value: _vm.selectedStrategy,
          callback: function ($$v) {
            _vm.selectedStrategy = $$v
          },
          expression: "selectedStrategy",
        },
      }),
      _vm._v(" "),
      _vm.selectedStrategy === _vm.IMPORT_INTO_EXISTS_TEMPLATE_STRATEGY
        ? _c("SelectTemplateBanner", {
            staticClass: "mt-3",
            attrs: { customers: _vm.customers },
            model: {
              value: _vm.selectedTemplates,
              callback: function ($$v) {
                _vm.selectedTemplates = $$v
              },
              expression: "selectedTemplates",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedStrategy === _vm.IMPORT_AND_CREATE_STRATEGY
        ? _c(
            "b-form-group",
            { staticClass: "mt-3", attrs: { label: "New layout name" } },
            [
              _c("b-form-input", {
                model: {
                  value: _vm.layoutName,
                  callback: function ($$v) {
                    _vm.layoutName = $$v
                  },
                  expression: "layoutName",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }